"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingState = void 0;
const react_1 = __importDefault(require("react"));
const generic_browser_lib_1 = require("@squiz/generic-browser-lib");
const LoadingState = () => (react_1.default.createElement("div", { className: "col-start-2 col-end-2" },
    react_1.default.createElement(generic_browser_lib_1.Spinner, { label: "Loading selection", className: "m-2" })));
exports.LoadingState = LoadingState;
